export default "__VITE_ASSET__CJUPKRFm__"